import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { NotificationsService } from 'angular4-notifications';
import * as moment from 'moment';
import { ValidateDateFuture } from '../../../validators/dateFuture.validator';

@Component({
  selector: 'app-add-game',
  templateUrl: './add-game.component.html'
})
export class AddGameComponent implements OnInit {

	formGame: FormGroup;
	game: any;
	formErrors: string;
	prizes: any;
	companyId: string;
	goSubmit: boolean = false;
	deliveryTypes: any;
	prizeTypes: any;
	gameCategories: any;
	step: number = 1;
	totaleValuePrizes: number = 0;
	endDate: any;
	isLoading: boolean = false;

	@ViewChild('fileInput') fileInput: ElementRef;
	@ViewChild('prizepic1') prizepic1: ElementRef;
	@ViewChild('prizepic2') prizepic2: ElementRef;
	@ViewChild('prizepic3') prizepic3: ElementRef;

  	constructor(
  		private http: HttpClient, 
  		private fb: FormBuilder,
  		private notificationService: NotificationsService) { }

  	ngOnInit() {

  		this.companyId = JSON.parse(localStorage.getItem('currentUser')).userid;

  		this.formGame = this.fb.group({
	  		'name' : [null, Validators.required],
	  		// TODO : gerer les lat long
	  		'latitude' : ['50.62925', Validators.required],
	  		'longitude' : ['3.0572560000001', Validators.required],
	  		'description' : [null, Validators.required],
	  		'category' : [null, Validators.required],
	  		'picture_url' : [null, Validators.required],
	  		'logo' : null,
	  		'duration' : [null, Validators.required],
	  		'total_value' : [null, Validators.required],
	  		'start_date' : [null, [Validators.required, ValidateDateFuture]],
	  		'end_date' : [null, Validators.required],
	  		'max_budget' : [null],
	  		'share_facebook' : [null],
	  		'like_facebook' : [null],
	  		'prizes' : this.fb.array([this.createPrize()]),})

  		this.getGameCategories();
  		this.getDeliveryTypes();
  		this.getPrizeTypes();
  	}

  	calculateEndDate(){
  		let dur = this.formGame.get('duration').value;
  		let debut = this.formGame.get('start_date').value;
  		if(dur != null && debut != null)
  		{
  			this.endDate = moment(debut);
	    	this.endDate.add(dur, 'days');
	    	this.formGame.get('end_date').setValue(this.endDate);
  		}
	}

  	submitGame(data){
  		event.preventDefault(); // disable reload page on submit
  		this.goSubmit = true;
  		this.isLoading = true;

  		if (this.formGame.valid) {

		  	// Get all values from the form
		  	const formModel = this.formGame.value;	  		

	  		console.log(formModel);

		    const req = this.http.put(environment.symfonyEndpointSecuredForCompany + environment.apiAddGame + this.companyId, formModel)
		        .subscribe(
		        res => {
		        	// console.log(res);
	            	this.formErrors = '';
	            	this.game = res;
	            	this.isLoading = false;
	            	this.step = 3;
		        },
		        err => {
		            if(err.status === 400){
		              this.formErrors = JSON.parse(err['error']).message;
		            }else{
		              this.notificationService.error('Oups', 'Une erreur est survenue.');
		              console.error(JSON.parse(err['error']).message);
		            }
	            	this.isLoading = false;
		        }
		    );
		}else{

	        this.isLoading = false;
	    	// const invalid = [];
	     //  	const controls = this.formGame.controls;
	     //  	for (const name in controls) {
	     //    	if (controls[name].invalid) {
	     //        	console.error(name + ' est invalide.');
	     //     	}
	     //  	}
	     //  	this.notificationService.error('Oups', 'Une erreur est survenue.');
		}

  	}

  	onFileChange(event) {
	    let reader = new FileReader();
	    if(event.target.files && event.target.files.length > 0) {
	      let file = event.target.files[0];
	      reader.readAsDataURL(file);
	      reader.onload = () => {
	        this.formGame.get('logo').setValue({
	          filename: file.name,
	          filetype: file.type,
	          value: reader.result.split(',')[1]
	        });
	        this.formGame.get('picture_url').setValue(file.name);
	      };
	    }
  	}

  	onMove(prize: any, position: number) {
  		prize.get('position').setValue(position + 1); // +1 because position starts at zero
	}

	createPrize(): FormGroup {
	    return this.fb.group({
	        'name': [null, Validators.required],
	        'description': [null, Validators.required],
	        'pictureUrl1' : [null, Validators.required],
	        'picture1' : null,
	        'pictureUrl2' : [null],
	        'picture2' : null,
	        'pictureUrl3' : [null],
	        'picture3' : null,
	        'value' : [null, Validators.required],
	        'position' : [null],
	        'delivery_type' : [null, Validators.required],
	        'prize_type' : [null, Validators.required]
	    });
  	}

  	addPrize(): void {
    	const control: FormArray = this.formGame.get('prizes') as FormArray;
    	control.push(this.createPrize());
  	}

  	removePrize(index){
	    const control: FormArray = this.formGame.get('prizes') as FormArray;
	    control.removeAt(index);
	}

	copyPrize(index){
  		console.log('index : ' + index);
	    const control: FormArray = this.formGame.get('prizes') as FormArray;
	    control.push(control.at(index));
	}

	loadPrizePic(picNum, event, prize) {
	    let reader = new FileReader();
	    if(event.target.files && event.target.files.length > 0) {
	      let file = event.target.files[0];
	      reader.readAsDataURL(file);
	      reader.onload = () => {
	      	// console.log(prize);
	        prize.get('picture' + picNum).setValue({
	          filename: file.name,
	          filetype: file.type,
	          value: reader.result.split(',')[1]
	        });
	        prize.get('pictureUrl' + picNum).setValue(file.name);
	      };
	    }
  	}

  	getDeliveryTypes(){
  		return this.http.get(environment.symfonyEndpointSecuredForCompany + environment.apiGetDeliveryTypes).map((res: Response) => res).subscribe(deliveryTypes => {
      this.deliveryTypes = deliveryTypes;})
  	}

  	getPrizeTypes(){
  		return this.http.get(environment.symfonyEndpointSecuredForCompany + environment.apiGetPrizeTypes).map((res: Response) => res).subscribe(prizeTypes => {
      this.prizeTypes = prizeTypes;})
  	}

  	getGameCategories(){
  		return this.http.get(environment.symfonyEndpointSecuredForCompany + environment.apiGetGameCategories).map((res: Response) => res).subscribe(gameCategories => {
      this.gameCategories = gameCategories;})
  	}

  	changeStep(index){
  		
  		if(index == 1){this.step = index;}
  		if(index == 2)
  		{
  			this.totaleValuePrizes = 0;
  			for (let item of this.formGame.get('prizes').value )
  			{
  				this.totaleValuePrizes += item.value;
  			}
  			this.formGame.get('total_value').setValue(this.totaleValuePrizes);
  			this.step = index;
  		}
  		if(index ==3)
  		{
  			this.submitGame(this.formGame);
  		}
  	}



}



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/components/company/add-game/add-game.component.ts